<template>
    <b-modal v-model="show" size="xl" title="БИНО ТУРИ">
        <div class="container-fluid" style="min-height: 400px;">
            <div class="row">
                <div class="col-12">
                    <label>Бино турини танланг<span class="red"> *</span></label>
                    <v-select v-model="building.cadastreBuilding" label="name"
                              :options="cadastreBuildings"
                              :filterable="false"
                              @search="onCadastreBuildingSearch"
                              @search:focus="onCadastreBuildingFocus"
                              @change="onChangeCadastreBuilding"
                    >
                        <template slot="option" slot-scope="option" v-if="option && option.name">
                            <div v-html="option.name" style="font-weight: bold"></div>
                            <template v-if="option.data">
                                <template
                                        v-if="!option.data.capitalGroupByCategory && option.data.capitalGroup && option.data.capitalGroup.length > 0">
                                    <div>Капиталлик гуруҳи: {{option.data.capitalGroup}}</div>
                                </template>
                                <template v-if="option.data.category && option.data.category.settings">
                                    <template v-for="category in Object.keys(option.data.category.settings)">
                                        <template
                                                v-if="option.data.category.settings[category].criteria && option.data.category.settings[category].criteria.length > 0">
                                            <div :key="category">
                                                Категория: {{category}}.
                                                {{criteriaAsText(option.data.category.settings[category])}}
                                            </div>
                                        </template>
                                    </template>
                                </template>
                            </template>
                            <template v-if="option.tableInfo && option.tableInfo.length > 0">
                                <div>Жадвал: {{option.tableInfo}}</div>
                            </template>
                        </template>
                    <template slot="selected-option" v-if="building && building.cadastreBuildings && building.cadastreBuildings.name">
                    <div v-html="building.cadastreBuildings.name"></div>
                    </template>
                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                    </v-select>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn float-right mr-2" @click="close">
                Чиқиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal';
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal';
    import initFilterModel from '@/shared/filter';

    export default {
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        props: {
            index: Number,
            building: {
                type: Object
            },
            cadastreBuildingFields: {
                type: Array
            },
            cadastreBuildingFieldReferences: {
                type: Object
            }
        },
        data() {
            return {
                show: false,
                cadastreSectionFilter: initFilterModel(),
                cadastreBuildings: []
            }
        },
        methods: {
            onCadastreBuildingSearch(searchTxt, loading) {
                loading(true);
                this.cadastreBuildings = [];
                this.cadastreSectionFilter.page.size = 1000;
                // this.cadastreSectionFilter.realEstateId = this.building.realEstateId;
                this.cadastreSectionFilter.realEstateId = this.$route.params.id && this.$route.params.id > 0 ? this.$route.params.id : null
                this.cadastreSectionFilter.search = searchTxt;
                this.cadastreSectionFilter.volume = this.building.volume;
                this.cadastreSectionFilter.floors = this.building.floors;
                this.$http.post('cadastre/building/search', this.cadastreSectionFilter)
                    .then(res => {
                        this.cadastreBuildings = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onCadastreBuildingFocus() {
                this.cadastreBuildings = [];
                this.cadastreSectionFilter.page.size = 1000;
                this.cadastreSectionFilter.realEstateId = this.$route.params.id && this.$route.params.id > 0 ? this.$route.params.id : null
                this.cadastreSectionFilter.search = '';
                this.cadastreSectionFilter.volume = this.building.volume;
                this.cadastreSectionFilter.floors = this.building.floors;
                this.$http.post('cadastre/building/search', this.cadastreSectionFilter)
                    .then(res => {
                        this.cadastreBuildings = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onChangeCadastreBuilding() {
                if (this.building.cadastreBuilding) {
                    this.show = false
                }
            },
            criteriaAsText(category_settings) {
                let text = "";
                if (category_settings) {
                    if (category_settings.hasOwnProperty('criteria')) {
                        const criteria_list = category_settings.criteria;
                        if (criteria_list && criteria_list.length > 0) {
                            criteria_list.forEach((criteria) => {
                                if (criteria && criteria.field) {
                                    const field = this.getFieldByCode(criteria.field);
                                    if (field) {
                                        if (criteria.valueMin || criteria.valueMax) {
                                            text += (field.name + ': ' + ((criteria.valueMin ? criteria.valueMin : '0.00') + ' - ' + (criteria.valueMax ? criteria.valueMax : '120 000.00')) + '. ');
                                        } else if (criteria.valueId) {
                                            const reference = this.getReferenceById(field.code, criteria.valueId);
                                            if (reference) {
                                                text += (' ' + field.name + ': ' + reference.name + '. ');
                                            }
                                        } else if (criteria.value) {
                                            text += (' ' + field.name + ': ' + criteria.value + '. ');
                                        }
                                    }
                                }
                            });
                        }
                        if (category_settings.capitalGroup && category_settings.capitalGroup.length > 0) {
                            text += (' Капиталлик гуруҳи: ' + category_settings.capitalGroup + '. ');
                        }
                    }
                }
                return text;
            },
            getFieldByCode(field_code) {
                const fields = this.cadastreBuildingFields.filter((field) => {
                    return field.code === field_code;
                });
                return (fields && fields.length > 0) ? fields[0] : null;
            },
            getReferenceById(code, id) {
                if (this.cadastreBuildingFieldReferences.hasOwnProperty(code)) {
                    const fieldReferences = this.cadastreBuildingFieldReferences[code];
                    const references = fieldReferences.filter((ref) => {
                        return ref.id === id
                    });
                    return references.length > 0 ? references[0] : null;
                } else {
                    return null;
                }
            },
            close() {
                this.show = false
            }
        },
        created() {
            this.$eventBus.$on('showCadastreBuildingSelectModal_'+this.index, ()=> {
                this.show = true
            })
        }
    }
</script>

<style scoped>

</style>